import React, { useMemo } from "react";
import classes from "./compareProCons.module.scss"
import { EllipsisOutlined, PlusOutlined } from "@ant-design/icons";
import { Popover, Spin } from "antd";
import cc from "classnames";
import { useState } from "react";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { MitigationOption } from "scenes/DecisionMatrix";
import useWindowSize from "../../../../utils/useWindowSize";
import moment from "moment";
import { DeletePros } from "redux/DecisionMatrix/DeletePros/action";
import { DeleteCons } from "redux/DecisionMatrix/DeleteCons/action";
import { UpdatePros } from "redux/DecisionMatrix/UpdatePros/action";
import { UpdateCons } from "redux/DecisionMatrix/UpdateCons/action";
import { generatePath, useLocation, useParams } from "react-router-dom";
import { GetCons } from "redux/DecisionMatrix/GetCons/action";
import { GetPros } from "redux/DecisionMatrix/GetPros/action";
import { ReactComponent as ProsPlusIcon } from "./pros_icon.svg";
import { ReactComponent as ConsPlusIcon } from "./cons_icon.svg";
import { ReactComponent as OptionsIcon } from "./options.svg";
import { ReactComponent as ArrowUp } from "../../../../assets/svg/up-arrow.svg";
import { ReactComponent as DownArrow } from "../../../../assets/svg/down-arrow.svg";
import styled from "styled-components";

const CompareProCons = ({ activeOptionCriteria, readOnly, setAiAssistant, drawerClosed, setConsPros, setIsChange,consProsContext, filterData }) => {
  // const { decisionId } = useParams()
  const dispatch = useDispatch();
  const [updaterProsCons, setProsCons] = useState([]);
  const [showInput, setShowInput] = useState("");
  const [editProsInput, setEditProsInput] = useState({});
  const [editConsInput, setEditConsInput] = useState({});
  const [pros, setPros] = useState([]);
  const [cons, setCons] = useState([]);
  const [localConsValue, setLocalConsValue] = useState("");
  const [localMitigationValue, setLocalMitigationValue] = useState("");
  const [showCompare, setShowCompare] = useState(true);
  const [isProsMob, setIsProsMob] = useState(true);
  const { width } = useWindowSize();
  const [addMitigation, setAddMitigation] = useState(null);
  const prosRef = useRef();
  const consRef = useRef();

  const [prosLimitError, setProsLimitError] = useState(false);
  const [editProsLimitError, setEditProsLimitError] = useState(false);
  const [consLimmitError, setConsLimmitError] = useState(false)
  const [consMigitationLimitError, setConsMigitationLimitError] = useState(false)
  const [editConsLimitError, setEditConsLimitError] = useState(false)
  const [editMitigationLimitError, setEditMitigationLimitError] = useState(false)
  const [deleteProsIds, setDeleteProsIds] = useState([]);
  const [deleteConsIds, setDeleteConsIds] = useState([]);
  const [deleteMitigation, setDeleteMitigation] = useState([])
  const [up, setUp] = useState(false);
  const [down, setDown] = useState(false);


  const mitigationRef = useRef("");
  const loadingImg = () => {
    return <Spin className={classes.centered} size="large" />;
  };
  const { success: updatedConsRed } = useSelector(
    (state) => state.updatedConsReducer
  );
  const { success: getConsRed } = useSelector((state) => state.getConsReducer);
  const { success: getProsRed } = useSelector((state) => state.getProsReducer);

  useEffect(() => {
    if (!activeOptionCriteria?.id) return;
    dispatch(GetCons(activeOptionCriteria?.id));
    dispatch(GetPros(activeOptionCriteria?.id));
  }, [activeOptionCriteria]);

  useEffect(() => {
    if (getProsRed) {
      setPros([
        ...getProsRed?.sort(
          (i1, i2) =>
            moment(i1?.created_at)?.valueOf() -
            moment(i2?.created_at)?.valueOf()
        ),
      ]);
    }
  }, [getProsRed]);

  useEffect(() => {
    // Map new pros and cons from consProsContext, ensuring existing data remains
    const newPros = consProsContext?.pros?.map((pro) => ({
      context: pro?.context,
      priority: null,
      option_criteria: activeOptionCriteria?.id,
      isChange: true,
    })) || [];
  
    const newCons = consProsContext?.cons?.map((con) => ({
      context: con?.context?.Description  ,
      mitigation: cons?.context?.Mitigation,
      priority: null,
      option_criteria: activeOptionCriteria?.id,
      isChange: true,
    })) || [];
  
    // Combine existing pros and new ones, and similarly for cons
    setPros((prevPros) => [...prevPros, ...newPros]);
    setCons((prevCons) => [...prevCons, ...newCons]);
  }, [consProsContext, activeOptionCriteria]);

  useEffect(() => {
    // Check if filterData is available and contains expected data
    if (filterData?.[0]?.consPros) {
      setPros(filterData[0].consPros.pros || []);
      setCons(filterData[0].consPros.cons || []);
    }
  }, [filterData]);

  useEffect(() => {
    if (getConsRed) {
      setCons([
        ...getConsRed?.sort(
          (i1, i2) =>
            moment(i1?.created_at)?.valueOf() -
            moment(i2?.created_at)?.valueOf()
        ),
      ]);
    }
  }, [getConsRed]);

  useEffect(() => {
    setCons([])
    setPros([])
  }, [drawerClosed])

  useEffect(() => {
    setConsPros(
      {
        cons: cons,
        pros: pros,
        deleteProsIds: deleteProsIds,
        deleteConsIds: deleteConsIds,

      }
    )
  }, [pros, cons])


  const addPros = async () => {
    setLocalConsValue("");
    setLocalMitigationValue("");

    if (updaterProsCons[0] === "pros") {
      // await editPros(updaterProsCons[1]);
      setProsCons([]);
      return;
    }

    if (prosRef?.current?.value) {
      if (removeLineBreaksReplaceAll(prosRef?.current?.value).length > 2000) {
        setProsLimitError(true)
      } else {
        setIsChange(false)
        setProsLimitError(false)
        setShowInput("");
        pros.push({ context: prosRef?.current?.value, priority: null, option_criteria: activeOptionCriteria?.id, isChange: true })
      }
    }
  };

  const addCons = async () => {
    setLocalConsValue("");
    setLocalMitigationValue("");

    if (updaterProsCons[0] === "cons") {
      await editCons(updaterProsCons[1]);
      setProsCons([]);
      return;
    }

    if (consRef.current.value) {
      if (removeLineBreaksReplaceAll(consRef?.current?.value).length > 2000) {
        setConsLimmitError(true)
      } else {
        setConsLimmitError(false)
      }
      if (removeLineBreaksReplaceAll(mitigationRef.current.value).length > 2000) {
        setConsMigitationLimitError(true)
      } else {
        setConsMigitationLimitError(false)
      }
      if (removeLineBreaksReplaceAll(consRef?.current?.value).length <= 2000 && removeLineBreaksReplaceAll(mitigationRef.current.value).length <= 2000) {
        setIsChange(false)
        const id = activeOptionCriteria?.id;
        const body = {

          option: activeOptionCriteria?.option,
          isChange: true,
          option_criteria: activeOptionCriteria?.id,
          priority: null,
          context: consRef?.current?.value,
          mitigation: mitigationRef?.current?.value || "",
        };
        cons.push(body)
        setShowInput("");
      }
    }
  };

  const removePros = (id, index) => {
    setIsChange(false);
    if (id) {
      deleteProsIds.push(id)
    }
    const newData = pros.filter((item, indexItem) => indexItem !== index)
    setPros(newData)
  };

  const removeCons = (id, index) => {
    setIsChange(false);
    if (id) {
      deleteConsIds.push(id)

    }
    const filterData = cons.filter((item, indexItem) => indexItem !== index)
    setCons(filterData)
  };

  const removeLineBreaksReplaceAll = str => {
    return str.replaceAll('\n', '');
  }

  // Function to pop item by ID
  const popItemById = (array, id) => {
    const index = array.findIndex(item => item.id === id);
    if (index !== -1) {
      return array.splice(index, 1)[0]; // Removes and returns the item
    }
    return null; // Return null if the item was not found
  }



  const editPros = async (prosId) => {
    const id = activeOptionCriteria?.id;
    const prosItem = pros?.filter(item => item.id === prosId)
    popItemById(pros, prosId)
    if (removeLineBreaksReplaceAll(prosRef?.current?.value).length > 2000) {
      setEditProsLimitError(true)
    }
    else {
      pros[prosId].context = prosRef?.current?.value
      pros[prosId].isChange = true;
      setEditProsLimitError(false)
      setEditProsInput({})
      setIsChange(false);
    }
  };

  const editCons = async (consId) => {

    if (consRef?.current) {
      if (removeLineBreaksReplaceAll(consRef?.current?.value).length > 2000) {
        setEditConsLimitError(true)
      } else {
        setEditConsLimitError(false)
      }
    }

    if (mitigationRef.current) {
      if (removeLineBreaksReplaceAll(mitigationRef?.current?.value).length > 2000) {
        setEditMitigationLimitError(true);
      } else {
        setEditMitigationLimitError(false)
      }
    }

    if (editConsLimitError === false && editMitigationLimitError === false) {
      if (consRef?.current?.value?.length > 0) {
        cons[consId].context = consRef?.current?.value;
        cons[consId].isChange = true;
      }
      if (mitigationRef?.current?.value?.length > 0) {
        cons[consId].mitigation = mitigationRef?.current?.value;
        cons[consId].isChange = true;
      }
      setIsChange(false)

      setEditConsInput({})
      setAddMitigation("");
    }
  };

  const localUpdatePros = (prosValue) => {
    let l = removeLineBreaksReplaceAll(prosValue)
    if (removeLineBreaksReplaceAll(prosValue).length > 2000) {
      setProsLimitError(true)
      setEditProsLimitError(true)
    } else {
      setProsLimitError(false)
      setEditProsLimitError(false)
    }
    if (updaterProsCons?.length) {
      const index = pros?.findIndex((p) => p.id === updaterProsCons[1]);
      const prosCopy = [...pros];
      prosCopy[index].context = prosValue;
      setPros([...prosCopy]);
    }
  };

  const handleClick = (action, flag, prosId, prior) => {

    let priorVal = prior; // Get the value from the backend
    if (priorVal === null) {
      priorVal = 0; // Set the value to 0 if it's null
    }

    let newValue;

    if (action === "increase") {
      newValue = priorVal < 3 ? priorVal + 1 : 3;
    } else if (action === "decrease") {
      newValue = priorVal > 0 ? priorVal - 1 : 0;
    }

    setEditProsInput({})
    const id = activeOptionCriteria?.id;
    if (flag === "pro") {
      pros[prosId].priority = newValue;
      pros[prosId].isChange = true;
    }
    if (flag === "con") {
      cons[prosId].priority = newValue;
      cons[prosId].isChange = true;
    }
  };

  const localUpdateCons = (consValue) => {
    if (removeLineBreaksReplaceAll(consValue).length > 2000) {
      setConsLimmitError(true)
      setEditConsLimitError(true)
    } else {
      setConsLimmitError(false)
      setEditConsLimitError(false)
    }
    if (updaterProsCons?.length) {
      const index = cons?.findIndex((c) => c.id === updaterProsCons[1]);
      const consCopy = [...cons];
      consCopy[index].context = consValue;
      setCons([...consCopy]);
    }
  };

  const localUpdateMitigation = (consValue) => {
    if (removeLineBreaksReplaceAll(consValue).length > 2000) {
      setConsMigitationLimitError(true)
      setEditMitigationLimitError(true)
    } else {
      setConsMigitationLimitError(false)
      setEditMitigationLimitError(false)
    }
    if (updaterProsCons?.length) {
      const index = cons?.findIndex((c) => c?.id === updaterProsCons[1]);
      const consCopy = [...cons];
      consCopy[index].mitigation = consValue;
      setCons([...consCopy]);
    }
  };


  return (
    <div className={classes.compareWrapper}>
      <>
        {width > 767 && (
          <div>
            {showCompare ? (
              <>
                <div className={classes.compareTextDiv}>
                  <div className={classes.compareText}>Compare</div>
                  {!readOnly && (
                    <div
                      onClick={() => setAiAssistant(true)}
                      className={classes.generateAI}
                    >
                      Generate with AI
                    </div>
                  )}
                </div>
                <div className={classes.compareTablet}>
                  <div className={classes.column}>
                    {/* <div
                      className={classes.header}
                      style={{ background: "#62B732" }}
                    >
                      <span>Pros</span>
                    </div> */}
                    <div className={classes.header_pros}>
                      <h5>Pros</h5>
                      <button
                        onClick={() => {
                          setShowInput("pros");
                          setProsLimitError(false);
                          setEditProsLimitError(false)
                        }}
                        disabled={readOnly}
                      >
                        <ProsPlusIcon /> Add Pro
                      </button>
                    </div>
                    {pros?.map((p, index) => {
                      const content = (
                        <div key={p.id} className={classes.item}>
                          <button
                            type="button"
                            onClick={async () => {
                              await setEditProsInput({ index });
                              prosRef.current.value = p?.context;
                            }}
                          >
                            EDIT
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              removePros(p?.id, index);
                            }}
                          >
                            DELETE
                          </button>
                        </div>
                      );
                      return (
                        <div key={p?.id} className={classes.prosWrapper}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div className={classes.pros}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  width: "100%",
                                }}
                              >
                                <div className={classes.details}>
                                  <div>{index + 1}.</div>
                                  {editProsInput?.index === index ? (
                                    <div>
                                      <textarea
                                        rows="1"
                                        className={classes.editPros}
                                        onBlur={() => {
                                          editPros(index);
                                        }}
                                        onKeyDown={(e) => {
                                          if (e.keyCode === 13) {
                                            editPros(index);
                                          }
                                        }}
                                        onChange={(e) =>
                                          localUpdatePros(e?.target?.value)
                                        }
                                        ref={prosRef}
                                        placeholder={"Enter a pro"}
                                        autoFocus={true}
                                        type="text"
                                        style={{ borderColor: editProsInput?.index === index && editProsLimitError ? '#f51e14' : null }}
                                      >
                                      </textarea>
                                      {editProsInput?.index === index && editProsLimitError && (<div style={{ color: '#f51e14', fontSize: 12 }}>Pros cannot be greater than 2000 characters.</div>)}
                                    </div>
                                  ) : (
                                    <span className={classes.context}>
                                      {p.context}
                                    </span>
                                  )}
                                </div>
                                <ActionItem>
                                  <Sorting>
                                    <Dot
                                      grey={
                                        p?.priority == 0 || p?.priority === null
                                      }
                                      green={p?.priority == 3}
                                      red={p?.priority == 1}
                                      orange={p?.priority == 2}
                                    ></Dot>
                                    <SmallText>
                                      {((p?.priority == 0 ||
                                        p?.priority === null) &&
                                        "None") ||
                                        (p?.priority == 1 && "Low") ||
                                        (p?.priority == 2 && "Medium") ||
                                        (p?.priority == 3 && "High")}
                                    </SmallText>
                                  </Sorting>
                                  <ButtonWrapper>
                                    <Button
                                    disabled={p?.priority === 3}
                                      onClick={() =>
                                        handleClick(
                                          "increase",
                                          "pro",
                                          index,
                                          p?.priority == "null"
                                            ? 1
                                            : p?.priority,



                                        )
                                      }
                                      style={{opacity: p?.priority === 3 ? 0.4 : 1}}
                                    >
                                      <ArrowUp />
                                    </Button>
                                    <Button
                                    disabled={p.priority === 0 || p?.priority === null}
                                      onClick={() =>
                                        handleClick(
                                          "decrease",
                                          "pro",
                                          index,
                                          p?.priority == "null"
                                            ? 0
                                            : p?.priority
                                        )
                                      }
                                      style={{opacity: p?.priority === 0 || p?.priority === null ? 0.4 : 1}}
                                    >
                                      <DownArrow />
                                    </Button>
                                  </ButtonWrapper>
                                </ActionItem>
                                {p.option_criteria && !readOnly && (
                                  <div className={classes.popover_container}>
                                    <Popover
                                      content={content}
                                      onClick={(e) => {
                                        e?.stopPropagation();
                                      }}
                                      trigger="focus"
                                    >
                                      <EllipsisOutlined rotate={90} />
                                    </Popover>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    {showInput !== "cons" && (
                      <div className={classes.buttonAdd}>
                        <button
                          type="button"
                          className={classes.button}
                          onClick={() => {
                            setShowInput("pros");
                            // setPros([...pros, {context: '', id: new Date().getTime()}])
                          }}
                          disabled={readOnly}
                        >
                          <PlusOutlined style={{ color: "#62B732" }} />
                          <span style={{ color: "#62B732" }}>
                            {updaterProsCons[0] === "pros" ? "Edit" : "Add"}
                          </span>
                        </button>
                      </div>
                    )}
                    <div style={{ padding: '15px 16px 10px', width: '100%' }}>
                      {showInput === "pros" && (
                        <>
                          <textarea
                            rows="1"
                            className={classes.inputPro}
                            onBlur={() => {
                              addPros();
                              // setShowInput('')
                            }}
                            onKeyDown={(e) => {
                              if (e.keyCode === 13) {
                                addPros();
                                // setShowInput('')
                              }
                            }}
                            onChange={(e) => localUpdatePros(e?.target?.value)}
                            ref={prosRef}
                            placeholder={"Enter a pro"}
                            autoFocus={true}
                            type="text"
                            style={{ borderColor: prosLimitError ? '#f51e14' : null }}
                          >
                          </textarea>
                          {prosLimitError && (<div style={{ color: '#f51e14', fontSize: 12, marginLeft: 15 }}>Pros cannot be greater than 2000 characters.</div>)}
                        </>
                      )}
                    </div>
                  </div>
                  {
                    <div className={classes.column}>
                      <div className={classes.header_cons}>
                        <h5>Cons</h5>
                        <button
                          type="button"
                          onClick={() => {
                            setShowInput("cons");
                            setConsLimmitError(false);
                            setConsMigitationLimitError(false);
                            setEditConsLimitError(false)
                            setConsMigitationLimitError(false)
                          }}
                          disabled={readOnly}
                        >
                          <ConsPlusIcon /> Add Cons
                        </button>
                      </div>
                      {cons?.map((p, index) => {
                        const content = (
                          <div key={p?.id} className={classes.item}>
                            <button
                              type="button"
                              onClick={async () => {
                                // await setShowInput("cons");
                                await setEditConsInput({ index });
                                consRef.current.value = p?.context;
                              }}
                              disabled={readOnly}
                            >
                              EDIT
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                removeCons(p?.id, index);
                              }}
                              disabled={readOnly}
                            >
                              DELETE
                            </button>
                            {!p?.mitigation && (
                              <button
                                type="button"
                                onClick={() => {
                                  setAddMitigation(index);
                                }}
                                disabled={readOnly}
                              >
                                ADD MITIGATION
                              </button>
                            )}
                            {p?.mitigation && (
                              <button
                                type="button"
                                onClick={async () => {
                                  await setAddMitigation(index);
                                  mitigationRef.current.value = p?.mitigation;
                                  
                                }}
                                disabled={readOnly}
                              >
                                EDIT MITIGATION
                              </button>
                            )}
                            {p?.mitigation && (
                              <button
                                type="button"
                                disabled={readOnly}
                                onClick={() => {
                                  let consCopy = [...cons];

                                  consCopy[index] = {
                                    ...consCopy[index],
                                    mitigation: "",
                                    isChange: true
                                  };
                                  setCons([...consCopy]);
                                  setIsChange(false);
                                }}

                              >
                                DELETE MITIGATION
                              </button>
                            )}
                          </div>
                        );

                        return (
                          <div className={classes.consMitigationWrapper}>
                            <div key={p?.id} className={classes.prosWrapper}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  height: "auto",
                                  justifyContent: "space-between",
                                  width: "100%",
                                }}
                              >
                                <div className={classes.pros}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      width: "100%",
                                    }}
                                  >
                                    <div className={classes.details}>
                                      <div>{index + 1}.</div>

                                      {editConsInput?.index === index ? (
                                        <div>
                                          <textarea
                                            rows="1"
                                            className={classes.editPros}
                                            onBlur={() => {
                                              editCons(index);
                                            }}
                                            onKeyDown={(e) => {
                                              if (e.keyCode === 13) {
                                                editCons(index);
                                              }
                                            }}
                                            onChange={(e) => {
                                              setLocalConsValue(e?.target?.value);
                                              localUpdateCons(e?.target?.value);
                                            }}
                                            ref={consRef}
                                            placeholder={"Enter a con"}
                                            autoFocus={true}
                                            type="text"
                                            required={true}
                                            style={{ borderColor: editConsInput?.index === index && editConsLimitError ? '#f51e14' : null }}
                                          >
                                          </textarea>
                                          {editConsInput?.index === index && editConsLimitError && (<div style={{ color: '#f51e14', fontSize: 12 }}>Cons cannot be greater than 2000 characters.</div>)}
                                        </div>
                                      ) : (
                                        <span className={classes.context}>
                                          {p?.context}
                                        </span>
                                      )}
                                    </div>
                                    <ActionItem>
                                      <Sorting>
                                        <Dot
                                          grey={
                                            p?.priority == 0 ||
                                            p?.priority === null
                                          }
                                          green={p?.priority == 3}
                                          red={p?.priority == 1}
                                          orange={p?.priority == 2}
                                        ></Dot>
                                        <SmallText>
                                          {((p?.priority == 0 ||
                                            p?.priority === null) &&
                                            "None") ||
                                            (p?.priority == 1 && "Low") ||
                                            (p?.priority == 2 && "Medium") ||
                                            (p?.priority == 3 && "High")}
                                        </SmallText>
                                      </Sorting>
                                      <ButtonWrapper>
                                        <Button
                                        disabled={p.priority === 3}
                                          onClick={() =>
                                            handleClick(
                                              "increase",
                                              "con",
                                              index,
                                              p?.priority == "null"
                                                ? 1
                                                : p?.priority
                                            )
                                          }
                                          style={{opacity: p?.priority === 3 ? 0.4 : 1}}
                                        >
                                          <ArrowUp />
                                        </Button>
                                        <Button
                                        disabled={p.priority === 0 || p?.priority === null}
                                          onClick={() =>
                                            handleClick(
                                              "decrease",
                                              "con",
                                              index,
                                              p?.priority == "null"
                                                ? 0
                                                : p?.priority
                                            )
                                          }
                                          style={{opacity : p.priority === 0 || p?.priority === null ? 0.4 : 1}}
                                        >
                                          <DownArrow />
                                        </Button>
                                      </ButtonWrapper>
                                    </ActionItem>
                                    {p.option_criteria && !readOnly && (
                                      <div
                                        className={classes.popover_container}
                                      >
                                        <Popover
                                          content={content}
                                          onClick={(e) => {
                                            e?.stopPropagation();
                                          }}
                                          trigger="focus"
                                          overlayClassName={classes.dropdown}
                                          placement="bottomRight"
                                        >
                                          <EllipsisOutlined
                                            rotate={90}
                                          />
                                        </Popover>
                                      </div>
                                    )}
                                  </div>
                                  <MitigationOption
                                    setCons={setCons}
                                    cons={cons}
                                    setAddMitigation={setAddMitigation}
                                    addMitigation={addMitigation}
                                    index={index}
                                    editCons={editCons}
                                    mitigationRef={mitigationRef}
                                    mitigationLimitError={editMitigationLimitError}
                                    setEditMitigationLimitError={setEditMitigationLimitError}
                                  />
                                </div>
                              </div>

                              <div></div>
                              {/*<hr className={classes.br}/>*/}
                            </div>
                            {/* <Mitigation
                                setCons={setCons}
                                cons={cons}
                                setAddMitigation={setAddMitigation}
                                addMitigation={addMitigation}
                                con={p}
                                editCons={editCons}
                                mitigationRef={mitigationRef}
                              /> */}
                          </div>
                        );
                      })}
                      {showInput !== "pros" && (
                        <div className={classes.buttonAdd}>
                          <button
                            type="button"
                            className={classes.button}
                            onClick={() => {
                              setShowInput("cons");
                            }}
                            disabled={readOnly}
                          >
                            <PlusOutlined style={{ color: "#ff0050" }} />
                            <span style={{ color: "#ff0050" }}>{"Add"}</span>
                          </button>
                        </div>
                      )}
                      {showInput === "cons" && (
                        <form
                          onBlur={event => {
                            if (consRef.current && consRef.current.contains(event.relatedTarget))
                              return false;
                            else if (mitigationRef.current && mitigationRef.current.contains(event.relatedTarget))
                              return false;

                            addCons();
                          }}
                          onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                              addCons();
                            }
                          }}
                          style={{ width: '100%' }}
                        >
                          <textarea
                            rows="1"
                            className={classes.inputCons}
                            onBlur={(e) => {
                              e?.preventDefault();
                            }}
                            onChange={(e) => {
                              setLocalConsValue(e?.target?.value);
                              localUpdateCons(e?.target?.value);
                            }}
                            ref={consRef}
                            placeholder={"Enter a con"}
                            required={true}
                            autoFocus={true}
                            type="text"
                            style={{ borderColor: consLimmitError ? '#f51e14' : null }}
                          >
                          </textarea>
                          {consLimmitError && (<div style={{ color: '#f51e14', fontSize: 12, marginLeft: 15 }}>Cons cannot be greater than 2000 characters.</div>)}
                          {localMitigationValue && !localConsValue && (
                            <div className={classes.consrequired}>
                              Cons is required
                            </div>
                          )}
                          <textarea
                            rows="1"
                            onBlur={(e) => {
                              e?.preventDefault();
                            }}
                            onClick={(e) => e?.stopPropagation()}
                            onChange={(e) => {
                              setLocalMitigationValue(e?.target?.value);
                              localUpdateMitigation(e?.target?.value);
                            }}
                            ref={mitigationRef}
                            value={mitigationRef?.current?.value}
                            placeholder={"Enter a mitigation (Optional)"}
                            className={classes.inputMitigation}
                            type="text"
                            style={{ borderColor: consMigitationLimitError ? '#f51e14' : null, marginBottom: consMigitationLimitError ? '7px' : null }}
                          >
                          </textarea>
                          {consMigitationLimitError && (<div style={{ color: '#f51e14', fontSize: 12, marginLeft: 15 }}>Mitigation cannot be greater than 2000 characters.</div>)}
                        </form>
                      )}
                    </div>
                  }
                </div>
              </>
            ) : (
              loadingImg()
            )}
          </div>
        )}
        {width <= 767 && (
          <div>
            {showCompare ? (
              <div className={classes.compareMobile}>
                <div className={classes.prosConsTitleWrp}>
                  <div
                    onClick={() => setIsProsMob(true)}
                    className={classes.headerMobile}
                    style={{ background: isProsMob && "#61b731" }}
                  >
                    <span>Pros</span>
                  </div>
                  <div
                    onClick={() => setIsProsMob(false)}
                    className={classes.headerMobile}
                    style={{ background: !isProsMob && "#ff0050" }}
                  >
                    <span>Cons</span>
                  </div>
                </div>
                {isProsMob && (
                  <div className={classes.columnMobile}>
                    {pros.map((p, index) => {
                      const content = (
                        <div key={p?.id} className={classes.itema}>
                          <button
                            type="button"
                            onClick={async () => {
                              await setShowInput("pros");
                              prosRef.current.value = p?.context;
                              // await setPros(pros.filter(pd => pd.id !== p.id))
                              setProsCons(["pros", p?.id]);
                            }}
                          >
                            EDIT
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              // setPros(pros?.filter((pd) => pd?.id !== p?.id));
                              removePros(p?.id, index);
                            }}
                          >
                            DELETE
                          </button>
                        </div>
                      );
                      return (
                        <div
                          key={p?.id || p?.name}
                          className={classes.prosWrapperMobile}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div className={classes.prosMobile}>
                              <div>{index + 1}.</div>
                              <span>{p?.context}</span>
                            </div>
                            {p?.option_criteria && !readOnly && (
                              <div>
                                <Popover
                                  content={content}
                                  onClick={(e) => {
                                    e?.stopPropagation();
                                  }}
                                  trigger="focus"
                                >
                                  <EllipsisOutlined
                                    rotate={90}
                                    style={{ marginBottom: "5px" }}
                                  />
                                </Popover>
                              </div>
                            )}
                          </div>

                          <hr className={classes.brMobile} />
                        </div>
                      );
                    })}
                    {showInput !== "pros" && (
                      <button
                        type="button"
                        className={classes.buttonAddMobile}
                        onClick={() => {
                          setShowInput("pros");
                          // setPros([...pros, {context: '', id: new Date().getTime()}])
                        }}
                        disabled={readOnly}
                      >
                        <PlusOutlined style={{ color: "#61b731" }} />
                        <span style={{ color: "#61b731" }}>
                          {updaterProsCons[0] === "pros" ? "Edit" : "Add a pro"}
                        </span>
                      </button>
                    )}
                    {showInput === "pros" && (
                      <input
                        className={classes.inputMobile}
                        onBlur={() => {
                          addPros();
                          // setShowInput('')
                        }}
                        onKeyDown={(e) => {
                          if (e.keyCode === 13) {
                            addPros();
                            // setShowInput('')
                          }
                        }}
                        onChange={(e) => localUpdatePros(e.target.value)}
                        ref={prosRef}
                        placeholder={"Enter a pro"}
                        autoFocus={true}
                        type="text"
                      />
                    )}
                  </div>
                )}
                {!isProsMob && (
                  <div className={classes.columnMobile}>
                    {cons?.map((p, index) => {
                      const content = (
                        <div key={p?.id} className={classes.item}>
                          <button
                            type="button"
                            onClick={async () => {
                              await setShowInput("cons");
                              consRef.current.value = p?.context;
                              mitigationRef.current.value = p?.mitigation;
                              setProsCons(["cons", p?.id]);
                            }}
                          >
                            EDIT
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              removeCons(p?.id, index);
                            }}
                          >
                            DELETE
                          </button>
                          {!p?.mitigation && (
                            <button
                              type="button"
                              onClick={() => {
                                setAddMitigation(index);
                              }}
                            >
                              ADD MITIGATION
                            </button>
                          )}
                          {p?.mitigation && (
                            <button
                              type="button"
                              onClick={async () => {
                                await setAddMitigation(index);
                                mitigationRef.current.value = p?.mitigation;
                              }}
                            >
                              EDIT MITIGATION
                            </button>
                          )}
                          {p?.mitigation && (
                            <button
                              type="button"
                              onClick={() => {

                                // cons[index].mitigation = ""
                                // cons[index].isChange = true;
                                // dispatch(
                                //   UpdateCons(
                                //     {
                                //       mitigation: "",
                                //     },
                                //     p?.id,
                                //     activeOptionCriteria?.id
                                //   )
                                // );

                                // let index = cons?.findIndex(
                                //   (c) => c === index
                                // );
                                let consCopy = [...cons];

                                consCopy[index] = {
                                  ...consCopy[index],
                                  mitigation: "",
                                  isChange: true
                                };
                                setCons([...consCopy]);
                              }}
                            >
                              DELETE MITIGATION
                            </button>
                          )}
                        </div>
                      );

                      return (
                        <div className={classes.consMitigationWrapperMobile}>
                          <div
                            key={p?.id}
                            className={classes.prosWrapperMobile}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                            >
                              <div className={classes.prosMobile}>
                                <div>{index + 1}.</div>
                                <span>{p?.context}</span>
                              </div>
                              {p?.option_criteria && !readOnly && (
                                <div>
                                  <Popover
                                    content={content}
                                    onClick={(e) => {
                                      e?.stopPropagation();
                                    }}
                                    trigger="focus"
                                    placement="bottomRight"
                                  >
                                    <EllipsisOutlined
                                      rotate={90}
                                      style={{ marginBottom: "5px" }}
                                    />
                                  </Popover>
                                </div>
                              )}
                            </div>
                            <div></div>
                            {/*<hr className={classes.br}/>*/}
                          </div>
                          <MitigationOption
                            setCons={setCons}
                            cons={cons}
                            setAddMitigation={setAddMitigation}
                            addMitigation={addMitigation}
                            index={index}
                            editCons={editCons}
                            mitigationRef={mitigationRef}
                          />
                        </div>
                      );
                    })}
                    {showInput !== "cons" && (
                      <button
                        type="button"
                        className={classes.buttonAddMobile}
                        onClick={() => {
                          setShowInput("cons");
                          // setIsFormSubmite(false)
                          // setCons([...cons, {context: '', id: new Date().getTime()}])
                        }}
                        disabled={readOnly}
                      >
                        <PlusOutlined style={{ color: "#ff0050" }} />
                        <span style={{ color: "#ff0050" }}>{"Add a con"}</span>
                      </button>
                    )}
                    {showInput === "cons" && (
                      <form
                        onBlur={() => {
                          mitigationRef?.current?.focus();
                        }}
                        onKeyDown={(e) => {
                          if (e?.keyCode === 13) {
                            addCons();
                          }
                        }}
                      >
                        <input
                          className={classes.inputMobile}
                          onBlur={(e) => {
                            e?.preventDefault();
                          }}
                          onChange={(e) => localUpdateCons(e?.target?.value)}
                          ref={consRef}
                          placeholder={"Enter a con"}
                          required={true}
                          autoFocus={true}
                          type="text"
                        />
                        <input
                          onBlur={(e) => {
                            e?.preventDefault();
                            addCons();
                          }}
                          onClick={(e) => e?.stopPropagation()}
                          onChange={(e) =>
                            localUpdateMitigation(e?.target?.value)
                          }
                          ref={mitigationRef}
                          value={mitigationRef?.current?.value}
                          placeholder={"Enter a mitigation (Optional)"}
                          className={classes.inputMitigationMobile}
                          type="text"
                        />
                      </form>
                    )}
                  </div>
                )}
              </div>
            ) : (
              loadingImg()
            )}
          </div>
        )}
      </>
      {/* )} */}
    </div>
  );
};

export { CompareProCons };
const ActionItem = styled.div`
    width: auto;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 0.1rem;
  `;
const Sorting = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.5rem;
  `;

const Dot = styled.div`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ grey, green, red, orange }) =>
    (grey && "#8e97a3") ||
    (green && "#4b8120") ||
    (red && "#f00001") ||
    (orange && "#feab3c")};
    margin: 0;
    padding: 0;
  `;
const SmallText = styled.p`
    color: #000000;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    margin: 0;
    padding: 0;
    padding-right: 3px;
  `;
const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-right: 8px;
    padding-left: 4px;
    transform: translateY(2px);
  `;
const Button = styled.button`
    outline: none;
    border: none;
    background-color: transparent;
    margin: 0;
    padding: 0;
    height: 12px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  `;
const Icon = styled.img`
    height: 8px;
  `;
